import React from 'react';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    content: "Found the perfect name for our local soccer team. The generator gave us options that really captured our team's spirit!",
    author: "James K.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
  },
  {
    content: "As a youth league organizer, I needed names for multiple teams. This tool made it so easy to generate unique names for each team.",
    author: "Sarah M.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
  },
  {
    content: "The sport-specific options really helped us find a name that fits our hockey team's identity. Highly recommended!",
    author: "Michael R.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=150&q=80"
  }
];

export default function SportsTeamTestimonials() {
  return (
    <section className="py-20 bg-indigo-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          What Teams Are Saying
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-lg transform transition-all duration-300 hover:scale-105">
              <Quote className="w-8 h-8 text-indigo-500 mb-4" />
              <p className="text-gray-600 mb-4">{testimonial.content}</p>
              <div className="flex items-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.author}
                  className="w-12 h-12 rounded-full mr-4 object-cover ring-2 ring-indigo-200"
                />
                <span className="font-semibold text-gray-900">{testimonial.author}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-indigo-600 font-medium">
            Join thousands of teams who found their perfect name
          </p>
        </div>
      </div>
    </section>
  )
}